export { EnergyType, BuildingType, BuildingAgeType } from '@eneco/flows/types';

export enum DetailsType {
  Gas = 'gas',
  Water = 'water',
  TapWater = 'tapwater',
  Electricity = 'electricity',
  Warmth = 'warmth',
  Redelivery = 'redelivery',
  Cashback = 'cashback',
  Cooling = 'cooling',
  TotalCosts = 'totalCosts',
  Warmtewisselaar = 'warmtewisselaar',
}

export enum OfferType {
  Fixed = 'fixed',
  Dynamic = 'dynamic',
  Variable = 'variable',
  ExtendStayer = 'extendStayer',
  ExtendTimeOfUse = 'extendTimeOfUse',
  ExtendRenewalBenefit = 'extendRenewalBenefit',
  None = 'none',
}

/**
 * The contract-type keys the offer step's product toggle filters on.
 *
 * These values double as the `name` of the Sitecore `contractTypeRadio` options, so they must stay
 * in sync with the CMS. Always produce them from {@link OfferType} rather than as string literals —
 * a mis-spelled key silently filters every offer away instead of failing loudly.
 */
export type ProductFilter = OfferType.Fixed | OfferType.Dynamic | OfferType.Variable;
